// React imports
import { createContext } from 'react'

export const NavigationContext = createContext("property")
